import { createContext, useContext, useEffect, useState } from 'react';
import { getMemberships, getProductItems } from '../services';
import { ProductItemModel, ProductItemsModel, StoreProviderValue, UserProviderValue } from '../models';
import { ProductItemStatuses, ProductItemTypes } from '../enums';
import { UserContext } from './user.context';
import { MembershipModel } from '../models/membership.model';
export const StoreContext = createContext({} as StoreProviderValue);

export const StoreProvider = ({ children }: any) => {
   const { isAuthenticated } = useContext<UserProviderValue>(UserContext);
   const [memberships, setMemberships] = useState<MembershipModel[]>([]);

   const [raffles, setRaffles] = useState<ProductItemsModel>({
      pagination: {
         page: 1,
         limit: 50,
         total: null,
         status: ProductItemStatuses.ALL,
         userEntriesOnly: false,
      },
      productItems: null,
   });

   const [userRaffleEntries, setUserRaffleEntries] = useState<ProductItemsModel>({
      pagination: {
         page: 1,
         limit: 50,
         total: null,
         status: ProductItemStatuses.ALL,
         userEntriesOnly: true,
      },
      productItems: null,
   });

   useEffect(() => {
      fetch(raffles, setRaffles);
   }, [raffles.pagination.page, raffles.pagination.status, isAuthenticated]);

   // useEffect(() => {
   //    fetchMemberships();
   // }, []);

   useEffect(() => {
      if (!isAuthenticated) {
         setUserRaffleEntries({
            pagination: {
               page: 1,
               limit: 50,
               total: null,
               status: ProductItemStatuses.ALL,
               userEntriesOnly: true,
            },
            productItems: null,
         });
         return;
      }
      fetch(userRaffleEntries, setUserRaffleEntries, true);
   }, [userRaffleEntries.pagination.page, userRaffleEntries.pagination.status, isAuthenticated]);

   const fetch = async (values: ProductItemsModel, setValues: (values: ProductItemsModel) => void, userEntriesOnly: boolean = false) => {
      try {
         const response = await getProductItems(values.pagination, ProductItemTypes.RAFFLE, userEntriesOnly);
         if (response.error || !response.data) {
            return;
         }

         if (values.pagination.page > 1) {
            setValues({
               pagination: { ...values.pagination, total: response.data.count },
               productItems: [...(values.productItems ?? []), ...response.data.productItems],
            });
         } else {
            setValues({
               pagination: { ...values.pagination, total: response.data.count },
               productItems: response.data.productItems,
            });
         }
      } catch (error) {
         console.error(error);
      }
   };

   const updateRaffleEntries = (entries: number, productItemId: string) => {
      if (raffles?.productItems) {
         setRaffles({
            ...raffles,
            productItems: raffles.productItems?.map((item) => {
               if (item.id === productItemId) {
                  return {
                     ...item,
                     totalEntries: item.totalEntries + entries,
                     userEntries: item.userEntries + entries,
                  };
               }

               return item as ProductItemModel;
            }),
         });
      }

      if (userRaffleEntries?.productItems) {
         setUserRaffleEntries({
            ...userRaffleEntries,
            productItems: userRaffleEntries.productItems?.map((item) => {
               if (item.id === productItemId) {
                  return {
                     ...item,
                     totalEntries: item.totalEntries + entries,
                     userEntries: item.userEntries + entries,
                  };
               }

               return item as ProductItemModel;
            }),
         });
      }
   };

   const fetchMemberships = async () => {
      const response = await getMemberships();
      if (response.error || !response.data) {
         return;
      }
      setMemberships(response.data);
   };

   return (
      <StoreContext.Provider
         value={{
            raffles: raffles,
            setRaffles: setRaffles,
            userRaffleEntries: userRaffleEntries,
            setUserRaffleEntries: setUserRaffleEntries,
            updateRaffleEntries,
            memberships: memberships,
            setMemberships: setMemberships,
         }}>
         {children}
      </StoreContext.Provider>
   );
};
